import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const passwordStrength = (pw = "") => {
  if (!pw) return null;
  if (pw.length < 6) return { label: "Too short", level: 0, tip: "Use at least 6 characters" };
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  if (s <= 1) return { label: "Weak", level: 1, tip: "Make it longer and add numbers or capitals" };
  if (s <= 3) return { label: "Good", level: 2, tip: "Add a symbol or more characters to make it stronger" };
  return { label: "Strong", level: 3, tip: "Great password" };
};

const COLORS = ["#B91C1C", "#DC2626", "#D97706", "#0B5E4E"];

export const PasswordStrength = ({ value, testid = "password-strength" }) => {
  const s = passwordStrength(value);
  if (!s) return null;
  return (
    <div data-testid={testid} className="-mt-1" aria-live="polite">
      <div className="flex gap-1">
        {[1, 2, 3].map((i) => <span key={i} className="h-1.5 flex-1 rounded-full transition-colors" style={{ background: s.level >= i ? COLORS[s.level] : "#EBE9E4" }} />)}
      </div>
      <div className="mt-1 flex justify-between gap-2 text-xs">
        <span className="font-semibold" style={{ color: COLORS[s.level] }} data-testid={`${testid}-label`}>{s.label}</span>
        <span style={{ color: "var(--sj-text-3)" }}>{s.tip}</span>
      </div>
    </div>
  );
};

export const PasswordInput = ({ className = "", testid, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input data-testid={testid} {...props} type={show ? "text" : "password"} className={`${className} pr-11`} />
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow((v) => !v)} aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md hover:bg-black/5 transition-colors" style={{ color: "var(--sj-text-3)" }}>
        {show ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
};
